import { Component } from 'preact'
import axios from 'axios'

import Phrase from '../../libs/translationsUtils/phrase'
import UserAvatar from '../User/UserAvatar'
import TrackingLink from '../link/tracking-link'

export const LeaderBoard = ({ title, leaderboard }) => {
  if (!leaderboard || !leaderboard.length) return null
  return <div class='box widget widget--likedusers qa-widget-most-liked'>
    <div class='box__content box__pad'>

      <h3 class='widget-title'>{title}</h3>

      <ul class='list list--userlikes qa-most-liked-post'>

        {leaderboard.map(({ author, likes }) =>
          <li>
            <div class='user flag flag--top'>

              <div class='flag__image '>
                <UserAvatar user={author} showRank />
              </div>
              <div class='user_data flag__body'>

                <TrackingLink
                  class='link username'
                  href={author.url}
                  track={{
                    type: 'Sidebar Widget Clicked',
                    widget: 'leaderboard'
                  }}
                  gaEvents={{
                    eventCategory: 'Homepage',
                    eventAction: 'Widget Clicked',
                    eventLabel: { Type: 'leaderboard' }
                  }}
                >
                  {author.name}
                </TrackingLink>

                <p class='text--meta'>
                  <Phrase p='{n} like.single|{n} like.plural' count={{ n: likes }} />
                </p>

              </div>

            </div>
          </li>)
        }
      </ul>
    </div>
  </div>
}

class LeaderBoardDataFetcher extends Component {
  constructor () {
    super()
    this.state = { leaderboard: [] }
  }

  async componentDidMount () {
    const { data } = await axios.get('/widget/getLeaderBoard', {
      params: {
        period: this.props.period,
        maxResults: this.props.maxResults
      }
    })
    this.setState({ leaderboard: data.items })
  }

  render (props) {
    return <LeaderBoard title={props.title} leaderboard={this.state.leaderboard} />
  }
}

export default LeaderBoardDataFetcher
